import React from "react";

import useSupplierDetail from "../../detail/useSupplierDetail";

import SupplierGridCard, { BookmarkToggle } from "./SupplierGridCard";
import { SupplierGridCardSkeleton } from "./SavedSuppliersSkeletons";

const SavedSupplierTile = ({ supplierId, pending, onOpen, onToggleSave }) => {
  const { detail, isLoading } = useSupplierDetail({ supplierId });

  if (detail) {
    return (
      <SupplierGridCard
        supplier={detail}
        saved
        pending={pending}
        onOpen={onOpen}
        onToggleSave={onToggleSave}
      />
    );
  }

  if (isLoading) return <SupplierGridCardSkeleton />;

  return (
    <li className="acc-card sv-card is-unavailable">
      <span className="sv-unavailable">
        <b>Supplier unavailable</b>
        <span>This supplier could not be loaded right now.</span>
      </span>

      <BookmarkToggle
        saved
        pending={pending}
        name="this supplier"
        onToggle={() => onToggleSave({ id: supplierId })}
      />
    </li>
  );
};

export default React.memo(SavedSupplierTile);
